import * as React from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { ProductConfigType } from '../../../types/administrationTypes';

interface ProductsConfigurationProps {
  productsList: ProductConfigType[];
  setProductsList: React.Dispatch<React.SetStateAction<ProductConfigType[]>>;
}

const ProductsConfiguration: React.FC<ProductsConfigurationProps> = ({ productsList, setProductsList }) => {
  const intl = useIntl();

  return (
    <div className="tff-administration-flex-column tff-administration-col-4">
      <Typography variant="h6" color="primary">
        <strong>{intl.formatMessage({ id: 'administration.myProducts' })}</strong>
      </Typography>
      {productsList.map((product: ProductConfigType, index: number) => {
        const handleProductsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const newState = productsList.map(item =>
            item.value === product.value ? { ...item, selected: event.target.checked } : item,
          );
          setProductsList(newState);
        };
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={product.selected}
                onChange={handleProductsChange}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                name={product.name}
                disabled={product.disabled}
              />
            }
            label={product.name}
            key={index}
            className="tff-administration-form-label-width"
          />
        );
      })}
    </div>
  );
};

export default ProductsConfiguration;
